<template>
	<nav
		class="site_header"
		:class="{ scrolled: isScrolled }"
		ref="site_header"
		:style="{
			'--nav-index': this.$store.state.nav_index_toggle ? '810' : '830',
		}"
	>
		<alert-banner
			v-if="toggle_alert_banner"
			:alert_banner_link="alert_banner_link"
			:alert_banner_text="alert_banner_text"
			:alert_banner_id="alert_banner_id"
		></alert-banner>
		<div class="top_menu" v-if="window.width >= 1240">
			<div class="container">
				<a href="/" class="site_header-brand"
					>
					<!-- <img
						:src="
							parsedGlobalSettings.general.logo
								? parsedGlobalSettings.general.logo
								: logo
						"
								alt="FPE"
						/> -->
						<animated-logo></animated-logo>
			</a>

				<div class="secondary_menu">
					<ul v-if="parsedMenu">
						<secondary-menu-item
							v-for="(menu_item, index) in filteredSecondaryMenu"
							:key="index"
							:menu_item="menu_item"
							:has-children="menu_item.children ? true : false"
							:selected="menu_item.object_id == Number(currentId)"
							:locale="locale"
							:theme="
								menu_item['classes'].includes('portal_logins')
									? 'portal'
									: 'top'
							"
						>
						</secondary-menu-item>
					</ul>

					<div class="spacer"></div>

					<!-- <primary-button
            v-if="parsedGlobalSettings.general"
            :link="parsedGlobalSettings.general.cta"
            :label="parsedGlobalSettings.general.cta.title"
            :target="parsedGlobalSettings.general.cta.target"
          ></primary-button> -->

					<a
						v-if="parsedGlobalSettings.general"
						:href="parsedGlobalSettings.general.cta.url"
						class="site_header-brand"
						:target="parsedGlobalSettings.general.cta.target"
						v-html="parsedGlobalSettings.general.cta.title"
					></a>

					<div class="search" @click="toggleSearch">
						<svg
							width="18"
							height="18"
							viewBox="0 0 18 18"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M7.85544 2.44576C4.72582 2.44576 2.18877 4.98281 2.18877 8.11242C2.18877 11.2421 4.72581 13.7791 7.85544 13.7791C9.31113 13.7791 10.6386 13.2302 11.6422 12.3281L12.0711 11.8992C12.9732 10.8956 13.5221 9.56811 13.5221 8.11242C13.5221 4.9828 10.9851 2.44576 7.85544 2.44576ZM13.9376 12.7804C14.9313 11.4876 15.5221 9.86903 15.5221 8.11242C15.5221 3.87825 12.0897 0.445755 7.85544 0.445755C3.62125 0.445755 0.188766 3.87824 0.188766 8.11242C0.188766 12.3467 3.62126 15.7791 7.85544 15.7791C9.61204 15.7791 11.2307 15.1883 12.5234 14.1946L16.1888 17.86L17.603 16.4458L13.9376 12.7804Z"
								fill="#4F58F5"
							/>
						</svg>
					</div>

					<div class="spacer"></div>
				</div>
			</div>
		</div>
		<div class="desktop_menu container alt" v-if="window.width >= 1240">
			<div class="center">
				<ul v-if="parsedMenu">
					<template v-for="(menu_item, index) in parsedMenu">
						<menu-item
							v-if="menu_item.classes.includes('mega-menu')"
							:key="index + '_mega'"
							:menu_item="menu_item"
							:has-children="menu_item.children ? true : false"
							:selected="menu_item.object_id == Number(currentId)"
							:locale="locale"
							@menuShow="toggleOverlay"
							:nav-height="height"
						>
						</menu-item>
						<secondary-menu-item
							v-else
							:key="index"
							:menu_item="menu_item"
							:has-children="menu_item.children ? true : false"
							:selected="menu_item.object_id == Number(currentId)"
							:locale="locale"
						>
						</secondary-menu-item>
					</template>
				</ul>
			</div>
		</div>

		<transition name="bounce">
			<div
				class="desktop_menu scrolled"
				v-if="window.width >= 1240 && isScrolled"
			>
				<div
					class="top_menu"
					:class="{ expanded: isScrollingUp }"
					v-if="window.width >= 1240 && isScrolled"
				>
					<div class="container">
						<a href="/" class="site_header-brand"
							>
							<!-- <img
								:src="
									parsedGlobalSettings.general.logo
										? parsedGlobalSettings.general.logo
										: logo
								"
								alt="FPE"
						/> -->
						<animated-logo></animated-logo>
					</a>

						<div class="secondary_menu">
							<ul v-if="parsedMenu">
								<secondary-menu-item
									v-for="(menu_item, index) in filteredSecondaryMenu"
									:key="index"
									:menu_item="menu_item"
									:has-children="menu_item.children ? true : false"
									:selected="menu_item.object_id == Number(currentId)"
									:locale="locale"
									:theme="
										menu_item['classes'].includes('portal_logins')
											? 'portal'
											: 'top'
									"
								>
								</secondary-menu-item>
							</ul>

							<div class="spacer"></div>

							<!-- <primary-button
            v-if="parsedGlobalSettings.general"
            :link="parsedGlobalSettings.general.cta"
            :label="parsedGlobalSettings.general.cta.title"
            :target="parsedGlobalSettings.general.cta.target"
          ></primary-button> -->

							<a
								v-if="parsedGlobalSettings.general"
								:href="parsedGlobalSettings.general.cta.url"
								class="site_header-brand"
								:target="parsedGlobalSettings.general.cta.target"
								v-html="parsedGlobalSettings.general.cta.title"
							></a>

							<div class="search" @click="toggleSearch">
								<svg
									width="18"
									height="18"
									viewBox="0 0 18 18"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M7.85544 2.44576C4.72582 2.44576 2.18877 4.98281 2.18877 8.11242C2.18877 11.2421 4.72581 13.7791 7.85544 13.7791C9.31113 13.7791 10.6386 13.2302 11.6422 12.3281L12.0711 11.8992C12.9732 10.8956 13.5221 9.56811 13.5221 8.11242C13.5221 4.9828 10.9851 2.44576 7.85544 2.44576ZM13.9376 12.7804C14.9313 11.4876 15.5221 9.86903 15.5221 8.11242C15.5221 3.87825 12.0897 0.445755 7.85544 0.445755C3.62125 0.445755 0.188766 3.87824 0.188766 8.11242C0.188766 12.3467 3.62126 15.7791 7.85544 15.7791C9.61204 15.7791 11.2307 15.1883 12.5234 14.1946L16.1888 17.86L17.603 16.4458L13.9376 12.7804Z"
										fill="#4F58F5"
									/>
								</svg>
							</div>

							<div class="spacer"></div>
						</div>
					</div>
				</div>
				<div class="container alt">
					<div class="center">
						<ul v-if="parsedMenu">
							<template v-for="(menu_item, index) in parsedMenu">
								<menu-item
									v-if="menu_item.classes.includes('mega-menu')"
									:key="index + '_mega'"
									:menu_item="menu_item"
									:has-children="menu_item.children ? true : false"
									:selected="menu_item.object_id == Number(currentId)"
									:locale="locale"
									@menuShow="toggleOverlay"
									:nav-height="height"
								>
								</menu-item>
								<secondary-menu-item
									v-else
									:key="index"
									:menu_item="menu_item"
									:has-children="menu_item.children ? true : false"
									:selected="menu_item.object_id == Number(currentId)"
									:locale="locale"
								>
								</secondary-menu-item>
							</template>
						</ul>
					</div>
				</div>
			</div>
		</transition>

		<div
			class="mobile_menu_nav container alt"
			v-if="!isScrolled && window.width < 1240"
		>
			<a href="/" class="site_header-brand"
				>
				<!-- <img
					:src="
						parsedGlobalSettings.general.logo
							? parsedGlobalSettings.general.logo
							: logo
					"
					alt="FPE"
			/> -->
			<animated-logo></animated-logo>
		</a>

			<div class="right">
				<!-- <primary-button
          v-if="parsedGlobalSettings"
          :link="parsedGlobalSettings.general.cta"
          :label="parsedGlobalSettings.general.cta.title"
          :target="parsedGlobalSettings.general.cta.target"
        ></primary-button>

        <template v-for="(menu_item, index) in parsedSecondaryMenu">
          <secondary-menu-item
            v-if="menu_item['classes'].includes('portal_logins')"
            :key="index"
            :menu_item="menu_item"
            :has-children="menu_item.children ? true : false"
            :selected="menu_item.object_id == Number(currentId)"
            :locale="locale"
            type="mobile"
            :theme="
              menu_item['classes'].includes('portal_logins') ? 'portal' : 'top'
            "
          >
          </secondary-menu-item>
        </template>

        <a
          class="portal_link"
          v-if="parsedGlobalSettings.general.portal_login"
          :href="parsedGlobalSettings.general.portal_login.url"
          :target="parsedGlobalSettings.general.portal_login.target"
          ><svg
            width="15"
            height="18"
            viewBox="0 0 15 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.64624 3.90342C4.64624 2.43048 5.8403 1.23642 7.31324 1.23642C8.78618 1.23642 9.98024 2.43048 9.98024 3.90342C9.98024 5.37636 8.78618 6.57042 7.31324 6.57042C5.8403 6.57042 4.64624 5.37636 4.64624 3.90342ZM7.31324 0.23642C5.28801 0.23642 3.64624 1.87819 3.64624 3.90342C3.64624 5.92865 5.28801 7.57042 7.31324 7.57042C9.33847 7.57042 10.9802 5.92865 10.9802 3.90342C10.9802 1.87819 9.33847 0.23642 7.31324 0.23642ZM3.00352 12.0927C4.08579 11.0104 5.55367 10.4024 7.08423 10.4024H7.54223C9.0728 10.4024 10.5407 11.0104 11.6229 12.0927C12.7052 13.175 13.3132 14.6429 13.3132 16.1734C13.3132 16.226 13.3029 16.278 13.2828 16.3265C13.2627 16.375 13.2332 16.4191 13.1961 16.4563C13.1589 16.4934 13.1148 16.5229 13.0663 16.543C13.0178 16.5631 12.9658 16.5734 12.9132 16.5734H1.71323C1.60714 16.5734 1.5054 16.5313 1.43039 16.4563C1.35538 16.3813 1.31323 16.2795 1.31323 16.1734C1.31323 14.6429 1.92125 13.175 3.00352 12.0927ZM7.08423 9.40244C5.28845 9.40244 3.56622 10.1158 2.29641 11.3856C1.0266 12.6554 0.313232 14.3777 0.313232 16.1734C0.313232 16.5447 0.460732 16.9008 0.723283 17.1634C0.985835 17.4259 1.34193 17.5734 1.71323 17.5734H12.9132C13.0971 17.5734 13.2791 17.5372 13.449 17.4669C13.6188 17.3965 13.7732 17.2934 13.9032 17.1634C14.0332 17.0334 14.1363 16.879 14.2067 16.7092C14.277 16.5393 14.3132 16.3573 14.3132 16.1734C14.3132 14.3777 13.5999 12.6554 12.3301 11.3856C11.0602 10.1158 9.33801 9.40244 7.54223 9.40244H7.08423Z"
              fill="#203136"
            />
          </svg>
        </a> -->

				<menu-button
					v-if="window.width <= 1240"
					@click.native="toggleMobileMenu()"
					:label="this.$store.state.mobile_menu ? 'Close' : 'Menu'"
					:type="this.$store.state.mobile_menu ? 'close' : 'open'"
				></menu-button>
			</div>
		</div>
		<transition name="bounce">
			<div
				class="mobile_menu_nav scrolled container alt"
				v-if="isScrolled && window.width < 1240"
			>
				<a href="/" class="site_header-brand"
					>
					<!-- <img
						:src="
							parsedGlobalSettings.general.logo
								? parsedGlobalSettings.general.logo
								: logo
						"
						alt="FPE"
				/> -->
				<animated-logo></animated-logo>
			</a>

				<div class="right">
					<primary-button
						v-if="parsedGlobalSettings && window.width >= 1240"
						:link="parsedGlobalSettings.general.cta"
						:label="parsedGlobalSettings.general.cta.title"
						:target="parsedGlobalSettings.general.cta.target"
					></primary-button>

					<template v-for="(menu_item, index) in parsedSecondaryMenu">
						<secondary-menu-item
							v-if="menu_item['classes'].includes('portal_logins')"
							:key="index"
							:menu_item="menu_item"
							:has-children="menu_item.children ? true : false"
							:selected="menu_item.object_id == Number(currentId)"
							:locale="locale"
							type="mobile"
							:theme="
								menu_item['classes'].includes('portal_logins')
									? 'portal'
									: 'top'
							"
						>
						</secondary-menu-item>
					</template>

					<a
						class="portal_link"
						v-if="parsedGlobalSettings.general.portal_login"
						:href="parsedGlobalSettings.general.portal_login.url"
						:target="parsedGlobalSettings.general.portal_login.target"
						><svg
							width="15"
							height="18"
							viewBox="0 0 15 18"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M4.64624 3.90342C4.64624 2.43048 5.8403 1.23642 7.31324 1.23642C8.78618 1.23642 9.98024 2.43048 9.98024 3.90342C9.98024 5.37636 8.78618 6.57042 7.31324 6.57042C5.8403 6.57042 4.64624 5.37636 4.64624 3.90342ZM7.31324 0.23642C5.28801 0.23642 3.64624 1.87819 3.64624 3.90342C3.64624 5.92865 5.28801 7.57042 7.31324 7.57042C9.33847 7.57042 10.9802 5.92865 10.9802 3.90342C10.9802 1.87819 9.33847 0.23642 7.31324 0.23642ZM3.00352 12.0927C4.08579 11.0104 5.55367 10.4024 7.08423 10.4024H7.54223C9.0728 10.4024 10.5407 11.0104 11.6229 12.0927C12.7052 13.175 13.3132 14.6429 13.3132 16.1734C13.3132 16.226 13.3029 16.278 13.2828 16.3265C13.2627 16.375 13.2332 16.4191 13.1961 16.4563C13.1589 16.4934 13.1148 16.5229 13.0663 16.543C13.0178 16.5631 12.9658 16.5734 12.9132 16.5734H1.71323C1.60714 16.5734 1.5054 16.5313 1.43039 16.4563C1.35538 16.3813 1.31323 16.2795 1.31323 16.1734C1.31323 14.6429 1.92125 13.175 3.00352 12.0927ZM7.08423 9.40244C5.28845 9.40244 3.56622 10.1158 2.29641 11.3856C1.0266 12.6554 0.313232 14.3777 0.313232 16.1734C0.313232 16.5447 0.460732 16.9008 0.723283 17.1634C0.985835 17.4259 1.34193 17.5734 1.71323 17.5734H12.9132C13.0971 17.5734 13.2791 17.5372 13.449 17.4669C13.6188 17.3965 13.7732 17.2934 13.9032 17.1634C14.0332 17.0334 14.1363 16.879 14.2067 16.7092C14.277 16.5393 14.3132 16.3573 14.3132 16.1734C14.3132 14.3777 13.5999 12.6554 12.3301 11.3856C11.0602 10.1158 9.33801 9.40244 7.54223 9.40244H7.08423Z"
								fill="#203136"
							/>
						</svg>
					</a>

					<menu-button
						v-if="window.width <= 1240"
						@click.native="toggleMobileMenu()"
						:label="this.$store.state.mobile_menu ? 'Close' : 'Menu'"
						:type="this.$store.state.mobile_menu ? 'close' : 'open'"
					></menu-button>
				</div>
			</div>
		</transition>

		<mobile-menu
			v-if="window.width <= 1240"
			:is-showing="this.$store.state.mobile_menu"
			:current-id="Number(currentId)"
			:menu-data="parsedMenu"
			:sec-menu-data="parsedSecondaryMenu"
			:global-settings="parsedGlobalSettings"
			:class="{ alert_open: this.$store.state.alert_bar_closed === false }"
			@trigger-toggle-search="emittedToggleSearch"
		>
		</mobile-menu>

		<transition name="fade">
			<div v-if="searchToggled" class="search_modal" ref="container">
				<div class="search_modal__inner">
					<div class="search_form">
						<svg
							width="18"
							height="18"
							viewBox="0 0 18 18"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M7.85544 2.44576C4.72582 2.44576 2.18877 4.98281 2.18877 8.11242C2.18877 11.2421 4.72581 13.7791 7.85544 13.7791C9.31113 13.7791 10.6386 13.2302 11.6422 12.3281L12.0711 11.8992C12.9732 10.8956 13.5221 9.56811 13.5221 8.11242C13.5221 4.9828 10.9851 2.44576 7.85544 2.44576ZM13.9376 12.7804C14.9313 11.4876 15.5221 9.86903 15.5221 8.11242C15.5221 3.87825 12.0897 0.445755 7.85544 0.445755C3.62125 0.445755 0.188766 3.87824 0.188766 8.11242C0.188766 12.3467 3.62126 15.7791 7.85544 15.7791C9.61204 15.7791 11.2307 15.1883 12.5234 14.1946L16.1888 17.86L17.603 16.4458L13.9376 12.7804Z"
								fill="#4F58F5"
							/>
						</svg>
						<form role="search" action="/" method="GET">
							<input
								type="text"
								name="s"
								value=""
								placeholder="Type to search..."
								ref="search"
							/>
						</form>
					</div>
					<close-button @click.native="toggleSearch" type="grey"></close-button>
				</div>
			</div>
		</transition>
		<transition-group name="slide-fade-vert" class="search-outer-wrapper">
			<div
				class="search-outer nectar"
				v-if="showSearch && window.width >= 1240"
				:key="1"
			>
				<div class="search">
					<div class="container" style="position: relative">
						<div class="searchbox">
							<div class="inner-wrap">
								<div class="col span_12">
									<form role="search" action="/" method="GET">
										<input
											type="text"
											name="s"
											value=""
											placeholder="Search"
											ref="search"
										/>
										<span>Hit enter to search or ESC to close</span>
									</form>
								</div>
							</div>
						</div>
						<div class="close" @click="showSearch = !showSearch">
							<a href="#">
								<span class="close-wrap">
									<span class="close-line close-line1"></span>
									<span class="close-line close-line2"></span>
								</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</transition-group>

		<transition name="fade">
			<div
				class="overlay"
				v-if="window.width <= 1240 && this.$store.state.mobile_menu"
			></div>
		</transition>

		<!-- Video Modal -->
		<transition name="fade">
			<div
				class="video_modal"
				v-if="this.$store.state.video_modal_open"
				@click="closeVideoModal"
			>
				<div class="iframe__container" @click.stop>
					<close-button
						class="close_image"
						type="grey"
						@click.native="closeVideoModal"
					></close-button>

					<iframe
						class="responsive__iframe"
						:src="videoModalUrl + '?autoplay=1'"
						frameborder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowfullscreen
					></iframe>
				</div>
			</div>
		</transition>
	</nav>
</template>

<script>
// import axios from 'axios';
import MenuItem from '../vue/MenuItem.vue';
// import MenuItemMega from '../vue/MenuItemMega.vue';
import SecondaryMenuItem from '../vue/SecondaryMenuItem.vue';
import MobileMenu from '../vue/MobileMenu.vue';
import Search from '../../images/search.svg';
import SearchGrey from '../../images/search-grey.svg';
import Close from '../../images/close.svg';
import CloseButton from './CloseButton.vue';
import PrimaryButton from './PrimaryButton.vue';
// import SecondaryButton from './SecondaryButton.vue';
import MenuButton from './MenuButton.vue';
import CallIcon from '../../images/call-icon.svg';
import AlertBanner from './AlertBanner.vue';
import AnimatedLogo from './AnimatedLogo.vue';

export default {
	data() {
		return {
			searchToggled: false,
			topScrollThreshold: 100,
			isScrolled: false,
			isScrollingUp: false,
			lastScrollY: 0,
			window: {
				width: 0,
				height: 0,
			},
			mobileMenuVisible: false,
			show: false,
			showSearch: false,
			showSearchMob: false,
			search: Search,
			close: Close,
			searchIcon: Search,
			searchIconGrey: SearchGrey,
			callIcon: CallIcon,
			overlay: false,
			height: 0,
		};
	},

	props: {
		logo: {},
		language_switcher: {},
		login_link: {},
		currentId: {},
		current_page: {},
		global_settings: {},
		menu: {},
		sec_menu: {},
		mobile_menu: {},
		locale: {},
		toggle_alert_banner: {},
		alert_banner_text: {},
		alert_banner_link: {},
		alert_banner_id: {},
	},

	computed: {
		parsedMenu() {
			if (this.menu) {
				return JSON.parse(this.menu);
			} else {
				return null;
			}
		},

		parsedSecondaryMenu() {
			if (this.sec_menu) {
				return JSON.parse(this.sec_menu);
			} else {
				return null;
			}
		},

		filteredSecondaryMenu() {
			if (!this.parsedSecondaryMenu) return [];

			return this.parsedSecondaryMenu.filter((menu_item) => {
				// Show on mobile regardless of hide-on-desktop class
				if (this.window.width < 1240) return true;

				// On desktop, hide items with 'hide-on-desktop' class
				return (
					!menu_item.classes || !menu_item.classes.includes('hide-on-desktop')
				);
			});
		},

		isDesktop() {
			return this.window.width >= 1240;
		},

		parsedMobileMenu() {
			if (this.mobile_menu) {
				return JSON.parse(this.mobile_menu);
			} else {
				return null;
			}
		},

		featuredPostsParsed() {
			if (this.featured_posts) {
				return JSON.parse(this.featured_posts);
			} else {
				return null;
			}
		},

		parsedGlobalSettings() {
			if (this.global_settings) {
				return JSON.parse(this.global_settings);
			} else {
				return null;
			}
		},

		parsedCategories() {
			if (this.categories) {
				return JSON.parse(this.categories);
			} else {
				return null;
			}
		},

		videoModalUrl() {
			return this.$store.state.video_modal_url;
		},
	},

	watch: {
		searchToggled() {
			this.$nextTick(() => {
				this.focusInput();
			});
		},
		isScrollingUp() {
			// Update height when scroll direction changes
			this.$nextTick(() => {
				this.updateHeight();
			});
		},
	},

	methods: {
		updateHeight() {
			const element = this.$refs.site_header;
			if (element) {
				let totalHeight = 0;

				if (this.isScrolled && this.window.width >= 1240) {
					// When scrolled, calculate height based on visibility of top menu
					const scrolledMenu = element.querySelector('.desktop_menu.scrolled');
					if (scrolledMenu) {
						const topMenu = scrolledMenu.querySelector('.top_menu');
						const mainMenu = scrolledMenu.querySelector('.container.alt');

						// Always include the main menu height
						const mainMenuHeight = mainMenu
							? mainMenu.getBoundingClientRect().height
							: 0;

						if (topMenu && this.isScrollingUp) {
							// Top menu is expanded, include its actual height
							const topMenuHeight = topMenu.getBoundingClientRect().height;
							totalHeight = topMenuHeight + mainMenuHeight;
						} else {
							// Top menu is collapsed (max-height: 0), only include main menu
							totalHeight = mainMenuHeight;
						}
					}
				} else {
					// When not scrolled, use the regular header height
					totalHeight = element.getBoundingClientRect().height;
				}

				this.height = totalHeight;
				document.documentElement.style.setProperty(
					'--nav-height',
					`${this.height}px`,
				);
			}
		},

		toggleOverlay(data) {
			console.log('Trying to toggle overlay');
			this.overlay = data;
		},

		menuItemOverSet() {
			this.show = false;
			console.log('Menu Item Over Set');
		},

		toggleSearch() {
			this.searchToggled = !this.searchToggled;
			this.show = false;
		},

		emittedToggleSearch() {
			this.searchToggled = !this.searchToggled;
			this.show = false;
		},

		focusInput() {
			if (this.$refs['search']) {
				this.$refs['search'].focus();
			}
		},

		toggleMobileMenu() {
			this.$store.commit('toggleMobileMenu', !this.$store.state.mobile_menu);
		},

		localeParse(url) {
			if (this.locale != 'en_au') {
				const localeUpdate = new URL(url);
				return '/' + this.locale + localeUpdate.pathname;
			} else {
				return url;
			}
		},

		localeParseSimple(url) {
			if (this.locale != 'en_au') {
				return '/' + this.locale + url;
			} else {
				return url;
			}
		},

		didScroll() {
			var elementTarget = document.querySelector('.site_header');
			const currentScrollY = window.scrollY;

			// Determine scroll direction
			this.isScrollingUp = currentScrollY < this.lastScrollY;
			this.lastScrollY = currentScrollY;

			this.isScrolled = currentScrollY > elementTarget.offsetHeight + 280;
			this.searchToggled = false;
			this.show = false;
			this.updateHeight();
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			this.updateHeight();

			// Close video modal on resize
			if (this.$store.state.video_modal_open) {
				this.closeVideoModal();
			}
		},

		localUrlSwap(value) {
			if (window.location.host === 'localhost:3000') {
				return value.replace('live-in-sa.test', 'localhost:3000');
			} else {
				return value;
			}
		},

		closeOnEscape() {
			let the = this;
			document.onkeydown = function (evt) {
				evt = evt || window.event;
				var isEscape = false;
				if ('key' in evt) {
					isEscape = evt.key === 'Escape' || evt.key === 'Esc';
				} else {
					isEscape = evt.keyCode === 27;
				}
				if (isEscape) {
					the.showSearch = false;
					the.showSearchMob = false;
				}
			};
		},

		onTouchStart(event) {
			// Prevent propagation to avoid triggering the onClickOutside immediately
			event.stopPropagation();
		},
		onClickOutside(event) {
			if (
				this.$refs.container &&
				!this.$refs.container.contains(event.target)
			) {
				// Touch event happened outside of the container
				// Perform your desired function here
				this.performFunction();
			}
		},
		performFunction() {
			let the = this;
			// Your function implementation here

			if (the.searchToggled) {
				this.toggleSearch();
			}
		},

		closeVideoModal() {
			this.$store.commit('closeVideoModal');
			document.body.classList.remove('modal-open');
		},
	},

	components: {
		MenuItem,
		SecondaryMenuItem,
		MobileMenu,
		CloseButton,
		PrimaryButton,
		MenuButton,
		AlertBanner,
		AnimatedLogo,
		// SecondaryButton,
		// MenuItemMega,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		window.addEventListener('scroll', this.didScroll);
		this.handleResize();
		this.$store.commit('toggleMobileMenu', false);
	},
	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
		this.closeOnEscape();
		document.addEventListener('touchstart', this.onClickOutside);
		document.addEventListener('mousedown', this.onClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener('touchstart', this.onClickOutside);
		document.removeEventListener('mousedown', this.onClickOutside);
	},
	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
		this.$store.commit('toggleMobileMenu', false);
	},
	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_header {
	position: relative;
	z-index: var(--nav-index);
	background: var(--fpe-light-grey);

	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		backdrop-filter: blur(6px);
		z-index: -1;
		pointer-events: none;
	}

	@media (max-width: 1279px) {
		border-bottom: unset;
	}

	.overlay {
		position: fixed;
		z-index: 100;
		top: 0;
		right: 0;
		bottom: 100%;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		pointer-events: none;
		opacity: 1;
		pointer-events: none;
		transition: 0.2s ease all;
	}

	.top_menu {
		background: var(--white);
		z-index: var(--z-index-top);

		> .container {
			.site_header-brand {
				grid-column: 1 / span 3;
				padding-top: 48px;
				padding-bottom: 48px;
			}

			.secondary_menu {
				grid-column: 4 / span 10;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				gap: 36px;

				.spacer {
					width: 1px;
					height: 100%;
					background: var(--medium-grey);
				}

				> a {
					font: normal normal 300 14px / 18px var(--primary-font-family);
					text-decoration: none;
					color: var(--fpe-blue);
					text-transform: uppercase;

					&:hover {
						text-decoration: underline;
					}
				}

				ul {
					list-style: none;
					padding: 0;
					display: flex;
					flex-direction: row;
					gap: 24px;
				}
			}

			.phone {
				grid-column: span 4;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				gap: 10px;

				li.menu_item__parent {
					&::v-deep {
						.parent_container {
							&.top {
								padding-right: 0 !important;

								a {
									text-decoration: underline;
								}
							}
						}
					}
				}
			}
		}

		.search {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 20px;
			height: 20px;

			@media (max-width: $tablet) {
				width: auto;
			}

			&:hover {
				cursor: pointer;
			}

			svg {
				path {
					fill: var(--fpe-blue);
				}
			}
		}
	}

	.desktop_menu {
		z-index: var(--z-index-top);

		&.scrolled {
			position: fixed;
			width: 100%;
			z-index: 800;
			top: 0;

			height: auto;

			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(#eae7e2, 0.8);
				backdrop-filter: blur(6px);
				z-index: -1;
				pointer-events: none;
			}

			.parent_container {
				padding: 6px 0;
			}

			.top_menu {
				max-height: 0;
				overflow: hidden;
				transition: max-height 0.3s ease-out;

				&.expanded {
					max-height: 200px; /* Adjust based on your top menu height */
				}
			}
		}
	}

	.container.alt {
		display: grid;
		grid-template-columns: auto 1fr;
		justify-content: space-between;
		align-items: center;

		@media (max-width: 1240px) {
			grid-template-columns: 100px 1fr;
		}

		.center {
			display: flex;
			grid-column: span 2;
			box-shadow: 0 1px 0 var(--white);

			&.center-right {
				justify-content: flex-end;
			}

			ul {
				list-style: none;
				padding: 0;
				margin: 0;
				display: flex;
				flex-direction: row;
				// column-gap: var(--spacer) * 2;
				justify-content: flex-end;
				align-items: center;
				grid-column: span 3;

				> li {
					// margin-right: calc(var(--spacer) * 1);

					&:last-of-type {
						margin-right: 0;
					}

					a {
						color: var(--light-blue);
						text-decoration: none;
						font-weight: 400;
						transition: 0.2s ease all;
						border-bottom: 1px solid transparent;
						padding-bottom: 10px;
						margin-left: 0;

						&:hover {
							border-bottom: 2px solid var(--light-blue);
							transition: 0.2s ease all;
						}
					}

					&.selected {
						a {
							border-bottom: 2px solid var(--light-blue);
							transition: 0.2s ease all;
						}
					}
				}

				> a {
					margin-left: calc(var(--spacer) * 2);
				}
			}
		}

		.right {
			display: flex;
			justify-content: flex-end;
			gap: 32px;
			height: 100%;
			align-items: center;

			@media (max-width: $tablet) {
				gap: 24px;
			}

			.search {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 40px;
				height: 40px;

				@media (max-width: $tablet) {
					width: auto;
				}

				&:hover {
					cursor: pointer;
				}

				svg {
					path {
						fill: var(--fpe-blue);
					}
				}
			}

			.portal_link {
				@media (max-width: 1240px) {
					margin-left: 0;
					padding-left: 0;
					display: flex;
					justify-content: center;
					align-items: center;

					svg {
						height: 25px;
						width: 25px;

						path {
							fill: var(--cobalt);
						}
					}
				}
			}

			.phone {
				display: flex;
				height: 24px;
				width: 24px;

				a {
					display: flex;
					height: 24px;
					width: 24px;

					svg {
						height: 24px;
						width: 24px;
					}
				}
			}
		}
	}

	&-brand {
		display: flex;

		img {
			height: 48px;

			@media (max-width: $tablet) {
				height: 24px;
			}
		}
	}

	.mobile_menu {
		width: 100%;
		padding: 0;
		padding: 0;
		background: white;
		height: calc(100vh - 57px);
		position: absolute;
		top: 40px;
		left: 0;
		display: flex;
		flex-direction: column;

		li {
			.menu_cta {
				margin-left: 20px;
				margin-top: 20px;
			}
		}
	}

	.menu_banner {
		width: 100%;
		border-bottom: 1px solid #ccc;
		padding: 10px 20px;
		margin-bottom: 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;

		a {
			color: var(--light-blue);
			font-size: 14px;
			line-height: 16.8px;
			font-weight: 600;

			@media (max-width: $mobile) {
				font-size: 18px;
				line-height: 20px;
				align-items: center;
			}

			&:hover {
				cursor: pointer;
			}
		}
	}

	.mobile_menu_nav {
		height: 72px;
		background: var(--white);
		position: relative;
		z-index: 60;
		/* border-bottom: var(--border); */

		/* @media (max-width: 1240px) {
			border-bottom: var(--border);
		} */

		&.scrolled {
			position: fixed;
			/* border-bottom: var(--border); */
			width: calc(100% - 80px);
			top: 0;

			@media (max-width: $mobile-xl) {
				width: calc(100% - 48px);
			}
		}
	}
}

.menu_toggle {
	&:hover {
		cursor: pointer;
	}

	svg {
		path {
			fill: var(--cobalt);
		}
	}
}

.search-outer-wrapper {
	width: 100%;
	position: fixed;
	top: 56px;
	z-index: 10;

	@media (max-width: $mobile) {
		top: 56px;
	}
}

.search-outer {
	@media (max-width: 767px) {
		top: 56px !important;
	}

	.searchbox {
		.inner-wrap {
			.col {
				padding-left: 0;
				padding-right: 0;
			}
		}
	}
}

.search_modal {
	position: fixed;
	z-index: 900;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background: rgba(#eae7e2, 0.8);
	backdrop-filter: blur(6px);
	display: flex;
	justify-content: center;
	align-items: center;

	.search_modal__inner {
		padding: 20px;
		border-radius: 8px;
		width: 100%;
		max-width: 800px;
		display: grid;
		grid-template-columns: 1fr auto;

		.search_form {
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: 10px;
			border-bottom: 1px solid var(--fpe-blue);

			svg {
				path {
					fill: var(--fpe-blue);
				}
			}

			form {
				width: 100%;

				input {
					width: 100%;
					-webkit-appearance: none;
					-moz-appearance: none;
					appearance: none;
					border: 0;
					background: none;
					font: normal normal 300 16px/24px var(--primary-font-family);
					transition: 0.2s ease all;
					outline: none;
					opacity: 0.8;
					color: var(--fpe-blue);

					&::-ms-input-placeholder {
						font: normal normal 300 16px/24px var(--primary-font-family);
						color: var(--fpe-blue);
					}

					&::placeholder {
						font: normal normal 300 16px/24px var(--primary-font-family);
						color: var(--fpe-blue);
					}
				}
			}
		}
	}
}

.slide-fade-enter-active {
	transition: all 0.25s ease;
}
.slide-fade-leave-active {
	transition: all 0.25s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(100%);
	// opacity: 0;
}

.slide-fade-vert-enter-active {
	transition: all 0.25s ease;
}
.slide-fade-vert-leave-active {
	transition: all 0.25s ease;
}
.slide-fade-vert-enter, .slide-fade-vert-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(-20px);
	opacity: 0;
}

.bounce-enter-active {
	animation: bounce-in 0.15s;
}

.bounce-leave-active {
	animation: bounce-in 0.15s reverse;
}

@keyframes bounce-in {
	0% {
		transform: translateY(-100px);
		opacity: 0;
	}
	// 50% {
	// 	transform: translateY(30px);
	// 	opacity: 1;
	// }
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

/* .fade-enter-active {
	transition: opacity 0.25s ease;
	transition-delay: 0.25s;
	opacity: 1;
}
.fade-leave-active {
	transition: all 0.25s ease;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
} */

.fade-enter-active {
	animation: fade-in 0.25s;
}

.fade-leave-active {
	animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.video_modal {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background: rgba(#eae7e2, 0.8);
	backdrop-filter: blur(6px);
	z-index: 9999;
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	grid-template-rows: 1fr auto 1fr;
	justify-content: center;
	align-items: center;

	@media (max-width: $mobile) {
		grid-template-columns: 16px 1fr 16px;
	}

	@media (max-width: $mobile) and (orientation: landscape) {
		grid-template-columns: repeat(12, 1fr);
	}

	.iframe__container {
		position: relative;
		width: 100%;
		aspect-ratio: 16 / 9;
		grid-column: 3 / span 8;
		grid-row: 2 / span 1;
		min-width: 800px;
		min-height: 400px;

		@media (max-width: $tablet) {
			grid-column: 2 / span 1;
			align-items: center;
			min-width: 300px;
		}

		@media (max-width: $mobile) and (orientation: portrait) {
			min-width: 100%;
			min-height: 20vh;
			min-width: 300px;
		}

		@media (max-width: $mobile) and (orientation: landscape) {
			grid-column: 4 / span 6;
			min-width: 300px;
		}

		.close_image {
			display: flex;
			position: absolute;
			grid-column: 11 / span 1;
			z-index: 10;
			top: -50px;
			right: -50px;

			@media (min-width: 0px) {
				right: 0px;
				width: 24px;
				height: 24px;
			}
		}
	}

	.responsive__iframe {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width: 100%;
		height: 100%;
		max-height: 100%;
		min-width: 100%;
		min-height: 400px;
		aspect-ratio: 16 / 9;

		@media (max-width: $mobile) {
			min-height: auto;
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteHeader.vue